import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    children: PropTypes.node,
    promptText: PropTypes.string,
    promptVariant: PropTypes.oneOf(['default', 'small']),
    tileListClass: PropTypes.string,
};

const defaultProps = {
    children: null,
    promptText: '',
    promptVariant: 'default',
    tileListClass: 'tileList',
};

function TileListEmpty({ children, promptText, promptVariant, tileListClass }) {
    let promptClass;
    if (!promptVariant || promptVariant === 'default') {
        promptClass = "prompt";
    }
    else if (promptVariant === 'small') {
        promptClass = "prompt--small";
    }

    return (
        <div className="no-listings">
            <div className={tileListClass}>
                {children}
            </div>
            <div className={promptClass}>
                {promptText}
            </div>
        </div>
    );
}

TileListEmpty.propTypes = propTypes;
TileListEmpty.defaultProps = defaultProps;

export default TileListEmpty;